module.exports = __webpack_public_path__ + "static/media/logo_dsn.6095811d.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/GetStarted/components/Logo/assets/logo_dsn.png
// module id = 1239
// module chunks = 0